import { MultiSelectOption, Tabs } from '@raisin/components-lib';
import { useT } from '@transifex/react';
import { useUSProductOffers } from 'hooks';
import messages from 'messages';
import React, { FC, useState } from 'react';
import { USProductOfferTableProps } from 'types';
import { ProductOfferTableContent } from './ProductOfferTableContent';
import * as S from './styles';
import {
  categoryTabsProps,
  financialInstitutionOptions,
  TabProps,
  updateSelectedFilters,
} from './utils';

export const ProductOfferTable: FC<USProductOfferTableProps> = ({
  productOffers,
  bankId,
  productId,
  bankLogoLinks = {},
  featuredProducts = [],
  inactiveProducts = [],
  categoryTabsToShow = [],
  financialInstitutions,
  showFinancialInstitutionsDropdown = true,
}) => {
  const t = useT();

  const { ...filteredProducts } = useUSProductOffers({
    productOffers,
    bankId,
    productId,
    featured: featuredProducts,
    inactive: inactiveProducts,
  });
  const [institutionFilters, setInstitutionFilters] = useState<MultiSelectOption[]>([]);

  const handleFilterChange = (selected: MultiSelectOption[]) => {
    setInstitutionFilters(
      updateSelectedFilters(institutionFilters, selected, financialInstitutionOptions),
    );
  };

  const preparedTabs = Object.keys(filteredProducts).reduce<TabProps[]>((acc, key) => {
    const categoryOffers = filteredProducts[key];
    const hideTab = categoryTabsToShow.length > 0 && !categoryTabsToShow.includes(key);

    if (!categoryOffers.length || hideTab) return acc;

    acc.push({
      content: (
        <ProductOfferTableContent
          offers={categoryOffers}
          bankLogoLinks={bankLogoLinks}
          isSavingsOffer={key === 'SAVINGS_ACCOUNT'}
          financialInstitutions={financialInstitutions}
          selectedFilters={institutionFilters}
          onFilterChange={handleFilterChange}
          showFinancialInstitutionsDropdown={showFinancialInstitutionsDropdown}
        />
      ),
      id: categoryTabsProps[key].id,
      label: categoryTabsProps[key].label,
    });

    return acc;
  }, []);

  if (!preparedTabs.length) {
    // no categories have offers present, don't display table
    return (
      <S.Container
        display="flex"
        justifyContent="center"
        alignItems="center"
        data-testid="no-products-message"
      >
        {t(messages.usOfferTableNoProducts)}
      </S.Container>
    );
  }

  return (
    <S.Container data-testid={'product-offer-table'}>
      <Tabs fullWidthTabs tabs={preparedTabs} testId="tab" />
      <S.Disclaimer variant="body1">{t(messages.usOfferTableDisclaimer)}</S.Disclaimer>
    </S.Container>
  );
};
